import { fetch } from '@/utils/fetch';

export const getInvoiceList = (page, size) => {
  return fetch({
    url: `/api/v2/my/company/receipted/invoices?page=${page}&size=${size}`,
    method: 'GET',
  });
};

export const getWxMpJsTicket = (pUrl, timestamp, tokenType = 'FWTOKEN', corpId = '', appId) => {
  return fetch({
    url: '/api/wechat/public/getJsTicket',
    data: {
      pUrl,
      timestamp,
      tokenType,
      corpId,
      appId: appId,
    },
    method: 'POST',
  });
};

export const getWxMpJsTicketNew = (pUrl, timestamp) => {
  let tokenType = 'FWTOKEN';
  return fetch({
    url: '/wechat-service/wechat/fw/getJsTicket',
    data: {
      pUrl,
      timestamp,
      tokenType,
    },
    method: 'POST',
  });
};

export default {
  getWxMpJsTicket,
  getWxMpJsTicketNew,
};
